import React from 'react';
import PropTypes from 'prop-types';
import { VertRate } from '@vertem-core/vertice-ds';
const SmallRate = ({ rate, total }) => {
  const ariaLabel = `Avaliação do produto: ${rate} estrelas de 5`
  return (
    <div className="vert-card-product-rate">
      <VertRate number={5} value={rate} disabled size={'small'} />
      { rate ? <span className='SmallRate-rate' aria-label={ariaLabel}>{rate}</span> : '' }
      { total ? <span className='SmallRate-total' aria-label={ariaLabel}>({total})</span> : '' }
    </div>
  );
};

SmallRate.propTypes = {
  rate: PropTypes.number,
  total: PropTypes.number,
};

export default SmallRate;
